import styled, { css } from 'styled-components';

interface ScreenSwapContainerProps {
  staticScale?: boolean;
  viewWidth?: number;
}

export const ScreenSwapContainer = styled.div<ScreenSwapContainerProps>`
  width: 100%;
  display: grid;
  grid-row-gap: 2rem;
  position: relative;
  z-index: 2;

  ${({ staticScale, viewWidth }) =>
    !staticScale || !viewWidth
      ? ''
      : css`
          position: relative;
          left: 50%;
          transform: translateX(-50%);
          width: calc(100% + ${viewWidth}vw);
        `}
`;
